import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import get from 'lodash.get';
import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { Button } from 'ui-components/components/button';
import { FloatInput } from 'ui-components/components/float-input';
import RMANumberLink from '../../../components/rma-number-link';
import { emptyArray } from 'ui-components/default-props/empty';

import style from './email-return-label-modal.module.less';

const messages = defineMessages({
  rmaNumber: {
    description: 'emailReturnLabel.rmaNumber',
    defaultMessage: 'RMA#',
    id: 'uPFFkl',
  },
  customerEmail: {
    description: 'emailReturnLabel.customerEmail',
    defaultMessage: 'Customer Email',
    id: 'RXHElu',
  },
});

const renderReturnLine = (returnEmail, index, updateEmailTo, intl) => {
  const emailRma = get(returnEmail, 'rmaNumber', '');
  const rmaNumber = `${intl.formatMessage(messages.rmaNumber)} ${emailRma}`;
  return (
    <div key={index} className={style['return-line']}>
      <RMANumberLink className={style['rma-number']} returnId={returnEmail.fulfillmentId} rmaNumber={rmaNumber} />
      <span>{returnEmail.name}</span>
      <FloatInput
        className={style['big-float-input']}
        label={intl.formatMessage(messages.customerEmail)}
        onChange={(value) => updateEmailTo(index, value)}
        value={returnEmail.emailTo}
      />
    </div>
  );
};

export const MultipleReturns = ({ fulfillmentEmails = emptyArray, updateEmailTo, closeModal, sendReturnLabels }) => {
  const intl = useIntl();
  return (
    <Modal className={style['email-return-label-modal']} size='large'>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage defaultMessage='Send Return Labels' description='emailReturnLabel.title' id='8AKOdm' />
      </ModalHeader>
      <ModalBody className={style['email-return-label-body']}>
        <div className={style.instructions}>
          <FormattedMessage
            defaultMessage='Send Return Label to one or more email addresses.'
            description='emailReturnLabel.instructions'
            id='pECEda'
          />
        </div>
        <div className={classnames(style['comma-separated-instructions'], style['border-bottom'])}>
          <FormattedMessage
            defaultMessage='Separate multiple addresses using commas.'
            description='emailReturnLabel.commaSeparatedInstructions'
            id='uJovAI'
          />
        </div>
        {fulfillmentEmails.map((ret, index) => renderReturnLine(ret, index, updateEmailTo, intl))}
      </ModalBody>
      <ModalFooter className={style.footer}>
        <Button onClick={closeModal} theme='tertiary'>
          <FormattedMessage defaultMessage='Cancel' description='emailReturnLabel.cancel' id='6SJj0I' />
        </Button>
        <Button onClick={sendReturnLabels} theme='primary'>
          <FormattedMessage defaultMessage='Send Emails' description='emailReturnLabel.sendMultiple' id='zRFkGX' />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

MultipleReturns.propTypes = {
  fulfillmentEmails: PropTypes.array,
  updateEmailTo: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  sendReturnLabels: PropTypes.func.isRequired,
};
